<kendo-dialog-titlebar class="bg-background! text-primary! pt-6! pr-3! pb-5! pl-5! font-bold" (close)="close()">
    <div class="flex flex-row items-center gap-2">
        @for (icon of options?.titleIcons; track icon) {
            <ng-icon [name]="icon" />
        }
        {{ options?.title | translate }}
    </div>
</kendo-dialog-titlebar>
<div class="flex h-full flex-col justify-evenly gap-4 p-4">
    @if (options.message) {
        <div class="flex items-center">
            <h6>{{ options.message | translate }}</h6>
        </div>
    }
    @if (options.properties?.length > 0) {
        <div class="grid grid-cols-12 gap-4">
            @for (property of options.properties; track property.id) {
                <div ngClass="col-span-{{ property.colSpan || 12 }}">
                    <app-input [config]="generateInputConfig(property)" [(value)]="model[getName(property)]" />
                </div>
            }
        </div>
    }
</div>
<ng-template #template></ng-template>
<kendo-dialog-actions
    class="px-4"
    layout="end"
    [ngStyle]="{
        display: !canEditPredicate(model) ? 'none' : 'inherit'
    }">
    <div class="flex w-full flex-col justify-between sm:flex-row sm:items-center">
        <div class="mb-2 grow sm:mb-0">
            @if (options.confirmMessage) {
                <span class="text-xs font-bold">{{ options.confirmMessage | translate }}</span>
            } @else {
                <div></div>
            }
        </div>
        <div class="flex justify-end space-x-4 sm:space-x-2">
            <app-button variant="secondary" [icon]="options?.cancelIcon" (click)="clear()">
                {{ options?.cancelText | translate }}
            </app-button>
            <app-button
                variant="primary"
                [icon]="options?.confirmIcon"
                [disabled]="!canConfirmPredicate(model)"
                (click)="confirmAction()">
                {{ options?.confirmText | translate }}
            </app-button>
        </div>
    </div>
</kendo-dialog-actions>
